import { render, staticRenderFns } from "./modal_pic_pedido.vue?vue&type=template&id=b1dc05f6&scoped=true&"
import script from "./modal_pic_pedido.vue?vue&type=script&lang=js&"
export * from "./modal_pic_pedido.vue?vue&type=script&lang=js&"
import style0 from "./modal_pic_pedido.vue?vue&type=style&index=0&id=b1dc05f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc05f6",
  null
  
)

export default component.exports